
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['on-close'],
});
